import { message } from 'antd';
import { useCallback } from 'react';
import { useState } from 'react';
import i18n from '../i18n.jsx';

export const imageTypes = [
  'gif',
  'jpeg',
  'jpg',
  'jpe',
  'jfi',
  'jif',
  'jfif',
  'pjpeg',
  'pjp',
  'png',
  'tif',
  'tiff',
  'bmp',
  'webp',
  'avif',
  'apng',
];

export const audioTypes = [
  'wav',
  'wave',
  'mp3',
  'ogg',
  'oga',
  'ogx',
  'ogm',
  'spx',
  'opus',
];

export const videoTypes = ['mp4', 'webm', 'avi', 'mpeg', 'ogg'];

export const documentTypes = [
  'txt',
  'pdf',
  'xls',
  'xlsx',
  'doc',
  'docx',
  'ppt',
  'pptx',
];

export const allAllowedTypes = [
  ...imageTypes,
  ...audioTypes,
  ...videoTypes,
  ...documentTypes,
];

export const wrongFileTypeErrorMessage = (file) =>
  i18n.t('Súbor {{name}} nie je povolený', { name: file.name });

function useFileDraggerFileValidation(
  allowedTypes = imageTypes,
  errorMessage = wrongFileTypeErrorMessage,
  maxCount = 1,
) {
  const [fileList, setFileList] = useState([]);

  const validateFileType = useCallback(
    ({ name }) => {
      if (!allowedTypes) {
        return true;
      }

      const extension = name.split('.').pop();

      if (extension) {
        return allowedTypes.includes(extension);
      }
    },
    [allowedTypes],
  );

  const beforeUpload = useCallback(
    (file) => {
      const isAllowedType = validateFileType(file);

      if (!isAllowedType) {
        setFileList((state) => [...state]);
        message.error(errorMessage(file));
        return false;
      }

      const fileWithURL = new File([file], file.name, { type: file.type });
      fileWithURL.url = URL.createObjectURL(file);
      setFileList((state) =>
        maxCount > 1 ? [...state, fileWithURL] : [fileWithURL],
      );
      return false;
    },
    [errorMessage, maxCount, validateFileType],
  );

  const onRemove = useCallback(
    (file) => {
      if (fileList.some((item) => item.uid === file.uid)) {
        setFileList((fileList) =>
          fileList.filter((item) => item.uid !== file.uid),
        );
        return true;
      }
      return false;
    },
    [fileList],
  );

  const clearFileList = useCallback(() => {
    setFileList([]);
  }, []);

  return {
    fileList,
    onRemove,
    beforeUpload,
    clearFileList,
  };
}

export default useFileDraggerFileValidation;
